import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';

import { ExecutionIndicator } from '../ConversationTranscript/ExecutionIndicator';
import { TranscriptComponent } from './TranscriptComponent';
import { VoiceTranscript } from './types';
import { formatTimestampToDate } from './utils';

export default function VoiceTranscripts({
  callStartTime,
  transcripts,
}: {
  callStartTime?: string;
  transcripts: VoiceTranscript[];
}) {
  const { t: translate } = useTranslation('intent-conversation-analytics');
  const widgetByBatchId = useMemo(() => {
    const map = new Map<string, VoiceTranscript>();
    for (const t of transcripts) {
      if (t.type === 'widget' && t.batch_id) {
        map.set(t.batch_id, t);
      }
    }
    return map;
  }, [transcripts]);

  if (transcripts.length === 0) {
    return null;
  }

  const startTime = callStartTime
    ? new Date(callStartTime).getTime() / 1000
    : transcripts[0].start_timestamp || 0;

  return (
    <DrawerContainer>
      <ExecutionIndicator
        message={translate('voiceTranscripts.conversationStartedWithBot')}
        timestamp={formatTimestampToDate(startTime)}
      />
      {transcripts.map((transcript, index) => {
        return (
          <TranscriptComponent
            key={index}
            startTime={startTime}
            transcript={transcript}
            widgetByBatchId={widgetByBatchId}
          />
        );
      })}
    </DrawerContainer>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- TODO: fix later
export const CellContainer = styled(Box)`
  line-height: 1.6;
  /* ellipsis when overflowing: */
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DrawerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
